import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth";
import { LoadingState, Shell } from "./components";
import { AuditPage } from "./pages/AuditPage";
import { LoginPage, SetupPage } from "./pages/AuthPages";
import { DataPage } from "./pages/DataPage";
import { IntegrationsPage } from "./pages/IntegrationsPage";
import { OverviewPage } from "./pages/OverviewPage";
import { SettingsPage } from "./pages/SettingsPage";
import { SystemPage } from "./pages/SystemPage";
import { TenantPage, TenantsPage } from "./pages/TenantsPage";
import { UsersPage } from "./pages/UsersPage";

function Protected() {
  const { session, loading } = useAuth();
  if (loading) {
    return <main className="boot-screen"><LoadingState label="Opening Nexus control room" /></main>;
  }
  return session ? <Outlet /> : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/setup" element={<SetupPage />} />
      <Route element={<Protected />}>
        <Route element={<Shell />}>
          <Route index element={<OverviewPage />} />
          <Route path="tenants" element={<TenantsPage />} />
          <Route path="tenants/:tenantId" element={<TenantPage />} />
          <Route path="integrations" element={<IntegrationsPage />} />
          <Route path="data" element={<DataPage />} />
          <Route path="system" element={<SystemPage />} />
          <Route path="audit" element={<AuditPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
